import { MenuScreen } from '../../../../../screens';

// ─────────────────────────────────────────────────────────────────────────────

export default function Page() {
  return <MenuScreen />;
}
